import { UpdateOrgMemberRequestSchema, UpdateOrgMemberResponseSchema } from './update-org-member.schema';
/**
 * Update Org Member Endpoint Contract
 * Updates an existing organization member by ID
 */ export const updateOrgMemberContract = {
    method: 'PATCH',
    path: '/api/v2/org-member/:id',
    description: 'Update an existing organization member by ID',
    requestSchema: UpdateOrgMemberRequestSchema,
    responseSchema: UpdateOrgMemberResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            404: 'Organization member not found'
        }
    }
};

//# sourceMappingURL=update-org-member.contract.js.map